

export const getUrlFromImage = (image) => {
	return !!image.childImageSharp ? image.childImageSharp.fluid.src : image;
};